import { c as _c } from "react/compiler-runtime";
import { Card } from "../ui/card";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { RenderIf } from "./render-if";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { getInitials } from "@/helpers/get-initials";
import { Rating } from "../reui/rating";
import { QuoteIcon } from "lucide-react";
type TestimonialCardProps = {
  quote: string;
  name: string;
  role: string;
  company: string;
  avatar?: string;
  rating: string | number;
  className?: string;
  truncateInSlider?: boolean;
};
export const TestimonialCard = t0 => {
  const $ = _c(39);
  const {
    quote,
    name,
    role,
    company,
    avatar,
    rating,
    className,
    truncateInSlider: t1
  } = t0;
  const truncateInSlider = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("border-border bg-card hover:border-foreground/20 flex h-full max-w-75 flex-col gap-0 p-6 transition-colors duration-200", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <QuoteIcon className="text-foreground size-7 rotate-180 opacity-20" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${rating} out of 5 stars`;
  const t5 = Number(rating);
  let t6;
  if ($[3] !== t5) {
    t6 = <Rating rating={t5} />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t6) {
    t7 = <div className="flex items-center justify-between">{t3}<div className="flex items-center gap-0.5" role="img" aria-label={t4}>{t6}</div></div>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== truncateInSlider) {
    t8 = cn("text-foreground flex-1 text-[15px] leading-relaxed", {
      "line-clamp-4 overflow-hidden leading-relaxed": truncateInSlider
    });
    $[8] = truncateInSlider;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== quote || $[11] !== t8) {
    t9 = <blockquote className={t8}>“{quote}”</blockquote>;
    $[10] = quote;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t9) {
    t10 = <div className="flex flex-1 flex-col gap-4">{t7}{t9}</div>;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== avatar || $[17] !== name) {
    t11 = <Avatar className="border-border size-10 overflow-hidden border">{avatar ? <Image src={avatar} alt={name} fill={true} className="object-cover grayscale" sizes="40px" /> : <AvatarFallback className="text-xs font-semibold">{getInitials(name)}</AvatarFallback>}</Avatar>;
    $[16] = avatar;
    $[17] = name;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== name) {
    t12 = <span className="text-foreground text-sm font-semibold">{name}</span>;
    $[19] = name;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = Boolean(company);
  let t14;
  if ($[21] !== company) {
    t14 = <span className="text-foreground font-medium">{company}</span>;
    $[21] = company;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14) {
    t15 = <RenderIf condition={t13}>, {t14}</RenderIf>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== role || $[27] !== t15) {
    t16 = <span className="text-muted-foreground text-xs">{role}{t15}</span>;
    $[26] = role;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t12 || $[30] !== t16) {
    t17 = <span className="flex flex-col gap-0.5">{t12}{t16}</span>;
    $[29] = t12;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t11 || $[33] !== t17) {
    t18 = <div className="mt-6 flex items-center gap-3">{t11}{t17}</div>;
    $[32] = t11;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t10 || $[36] !== t18 || $[37] !== t2) {
    t19 = <Card className={t2}>{t10}{t18}</Card>;
    $[35] = t10;
    $[36] = t18;
    $[37] = t2;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
};